import React from 'react';
import { Route, Switch } from 'react-router-dom';

import HostEventList from './components/HostEventList';
import HostEvent from './components/HostEvent';

const ChannelHost = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={HostEventList} />
    <Route exact path={`${match.url}/event`} component={HostEvent} />
  </Switch>
);

export default ChannelHost;

export * from './modules/actions';
export * from './modules/reducer';
